import { render, staticRenderFns } from "./NewYachtIndex.vue?vue&type=template&id=aa2cfbae&"
import script from "./NewYachtIndex.vue?vue&type=script&lang=js&"
export * from "./NewYachtIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports